import { FilteredRequests, Sort } from "@assets/requestsTypes";
import { ActiveRequest, JonarAPIResponse } from "@assets/types";
import { ArrayUtilities } from "@assets/utilities";
import { NormalizedFilters } from "@samskip/frontend-components";
import axios, { AxiosResponse } from "axios";

const JonarAPI = process.env.JonarAPI;

export interface BackendFilters extends NormalizedFilters {
  SearchString: string;
}

class RequestService {
  getActiveBookings = async (partner: string): Promise<ActiveRequest> => {
    return await axios
      .post(
        `${JonarAPI}/requests/active`,
        {
          partnerCode: partner,
        },
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          withCredentials: true,
        }
      )
      .then((res: AxiosResponse<JonarAPIResponse<ActiveRequest>>) => {
        return res.data.ReturnItem.Data;
      });
  };

  getRequestsWithFilters = async ({
    pageNumber,
    pageSize,
    sort,
    isSelectedCompany,
    filters,
  }: {
    pageNumber: number;
    pageSize: number;
    sort: Sort;
    isSelectedCompany: boolean;
    filters?: BackendFilters;
  }) => {
    const flatParams = ArrayUtilities.flattenFilters(filters);
    const res: AxiosResponse<JonarAPIResponse<FilteredRequests[]>> = await axios.get(
      `${JonarAPI}/requests/filteredrequests`,
      {
        params: {
          page: pageNumber,
          pageSize: pageSize,
          ...sort,
          isSelectedCompany: isSelectedCompany,
          ...flatParams,
        },
        paramsSerializer: {
          indexes: null,
        },
        withCredentials: true,
      }
    );
    return res.data.ReturnItem.Data;
  };
}

export default new RequestService();
